import { Avatar1, Avatar2, Avatar3, Avatar4 } from "./Avatar";
import { CountryIcon } from "./Icons";
import { ToggleSwitch } from "../components/Reusable/ToggleSwitch";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Faq } from "../pages/Products/types";

export const users = [
  {
    id: 1,
    avatar: <Avatar1 />,
    email: "bill.sanders@example.com",
    username: "Sandeeps",
    FirstName: "Diane",
    LastName: "Lane",
    role: "Super Admin",
    Country: <CountryIcon />,
  },
  {
    id: 2,
    avatar: <Avatar2 />,
    email: "jessica.hanson@example.com",
    username: "shivam98",
    FirstName: "Richard",
    LastName: "Ronalds",
    role: "Customer Service",
    Country: <CountryIcon />,
  },
  {
    id: 3,
    avatar: <Avatar3 />,
    email: "kenzi.lawson@example.com",
    username: "Keerti",
    FirstName: "Cody",
    LastName: "Fox",
    role: "Accountant",
    Country: <CountryIcon />,
  },
  {
    id: 4,
    avatar: <Avatar4 />,
    email: "michelle.rivera@example.com",
    username: "Herocoder",
    FirstName: "Philips",
    LastName: "Richards",
    role: "Admin",
    Country: <CountryIcon />,
  },
];
export const products = [
  {
    id: 1,
    image: "/images/PUBG.JPEG",
    product: "PUBG Mobile UC",
    category: "Mobile Game",
    status: "Published",
    Country: "NG, USA, GHN",
  },
  {
    id: 2,
    image: "/images/Fortnite.png",
    product: "Fortnite",
    category: "PC Game",
    status: "Published",
    Country: "NG, USA, GHN",
  },
  {
    id: 3,
    image: "/images/Steam.png",
    product: "Steam",
    category: "Mobile Game",
    status: "Draft",
    Country: "NG, USA, GHN",
  },
  {
    id: 4,
    image: "/images/COD.png",
    product: "Call of duty Mobile",
    category: "Herocoder",
    status: "Published",
    Country: "NG, USA, GHN",
  },
  {
    id: 5,
    image: "/images/EAFCMobile.png",
    product: "EA FC Mobile",
    category: "Mobile Game",
    status: "Draft",
    Country: "NG, USA, GHN",
  },
  {
    id: 6,
    image: "/images/FIFA.png",
    product: "League of Legends",
    category: "Mobile Game",
    status: "Published",
    Country: "NG, USA, GHN",
  },
  {
    id: 7,
    image: "/images/CounterStrike.png",
    product: "Counter-Strike: Global Offensive (CS:GO)",
    category: "PC Game",
    status: "Draft",
    Country: "NG, USA, GHN",
  },
  {
    id: 8,
    image: "/images/FIFA.png",
    product: "FIFA Series",
    category: "PC Game",
    status: "Published",
    Country: "NG, USA, GHN",
  },
  {
    id: 9,
    image: "/images/CODWarzone.png",
    product: "Call of Duty: Warzone",
    category: "PC/Console Game",
    status: "Draft",
    Country: "NG, USA, GHN",
  },
  {
    id: 10,
    image: "/images/ApexLegend.png",
    product: "Apex Legends",
    category: "PC/Console Game",
    status: "Published",
    Country: "NG, USA, GHN",
  },
];

export const data = [
  {
    image: "/images/COD.png",
    title: "DarkLordNathan",
    game: "Call of duty: Mobile",
  },
  {
    image: "/images/COD.png",
    title: "DarkLordNathan",
    game: "Call of duty: Mobile",
  },
  {
    image: "/images/PUBG.jpeg",
    title: "DarkLordNathan",
    game: "Call of duty: Mobile",
  },
];

export const purchases = [
  {
    id: 6065,
    date: "1 Feb, 2020",
    time: "01:34 pm",
    status: "Pending",
    items: 3,
    amount: "₦1,000",
  },
  {
    id: 9151,
    date: "24 May, 2020",
    time: "01:08 pm",
    status: "Successful",
    items: 3,
    amount: "₦12,000",
  },
  {
    id: 8013,
    date: "21 Sep, 2020",
    time: "02:10 pm",
    status: "Reversed",
    items: 2,
    amount: "₦1,000",
  },
  {
    id: 9261,
    date: "21 Sep, 2020",
    time: "02:30 pm",
    status: "Rejected",
    items: 2,
    amount: "₦1,120",
  },
];

export const categoryName = [
  {
    id: 1,
    name: "Mobile Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 2,
    name: "PC Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 3,
    name: "Console Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 4,
    name: "PC/Console Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 5,
    name: "PC/Console/Mobile Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 6,
    name: "Gift Card",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 7,
    name: "Airtime",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 8,
    name: "Data",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 9,
    name: "Electricity",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
  {
    id: 10,
    name: "PC/Console Game",
    status: (
      <div className="flex items-center gap-2">
        <span>Available</span>
        <ToggleSwitch />
      </div>
    ),
    action: <BsThreeDotsVertical />,
  },
];

export const demoPackages = [
  {
    id: 1,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: false,
  },
  {
    id: 2,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: false,
  },
  {
    id: 3,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: true,
  },
  {
    id: 4,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: false,
  },
  {
    id: 5,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: false,
  },
  {
    id: 6,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: true,
  },
  {
    id: 7,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: false,
  },
  {
    id: 8,
    image: "/images/CODCD.png",
    product: "880 CP",
    quantity: 200,
    price: "₦14,850",
    subcategory: "COD Points",
    discount: "12%",
    discountStatus: true,
  },
  {
    id: 9,
    image: "/images/MCODM.png",
    product: "Battle Pass Premium",
    quantity: 200,
    price: "₦14,850",
    subcategory: "Battle Pass",
    discount: "12%",
    discountStatus: true,
  },
  {
    id: 10,
    image: "/images/MCODM.png",
    product: "Battle Pass Premium",
    quantity: 200,
    price: "₦14,850",
    subcategory: "Battle Pass",
    discount: "12%",
    discountStatus: false,
  },
];

export const faq: Faq[] = [
  {
    id: 1,
    question: "Faq Question Title",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Integer vitae eu aliquam ornare ut dignissim consequat. Porttitor et commodo et nec gravida fringilla. Sapien non aliquam massa.",
  },
  {
    id: 2,
    question: "Faq Question Title",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Integer vitae eu aliquam ornare ut dignissim consequat. Porttitor et commodo et nec gravida fringilla. Sapien non aliquam massa.",
  },
  {
    id: 3,
    question: "Faq Question Title",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Integer vitae eu aliquam ornare ut dignissim consequat. Porttitor et commodo et nec gravida fringilla. Sapien non aliquam massa.",
  },
];

export const settingsData = [
  {
    id: 1,
    setting: "data_master_MTN",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 2,
    setting: "data_master_GLO",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 3,
    setting: "data_master_AIRTEL",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 4,
    setting: "data_master_ETISALAT",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 5,
    setting: "contact_whatsapp_number",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 6,
    setting: "contact_email_address",
    defaultValue: "1",
    type: "Text",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 7,
    setting: "contact_call_number1",
    defaultValue: "",
    type: "Text",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 8,
    setting: "contact_call_number2",
    defaultValue: "",
    type: "Text",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 9,
    setting: "cable_master",
    defaultValue: "",
    type: "Text",
    visibleToUser: "Visible",
    action: "Edit",
  },
  {
    id: 10,
    setting: "notification",
    defaultValue: "1",
    type: "Dropdown",
    visibleToUser: "Visible",
    action: "Edit",
  },
];
